import { StringFormatter } from '@repo/toolkit/string'
import Button from '@repo/ui/button'
import { Column } from '@repo/ui/data-table'
import Loader from '@repo/ui/loader'
import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'

import { API } from '../../../api/apis.config'
import { getMission } from '../../../api/missions/get-mission'
import { Staff, StaffFilters } from '../../../lib/types/models/staff/staff'
import { IdInput } from '../../../lib/types/utils'
import DynamicDataTable from '../../elements/dynamic-table'
import { ItemNotFound } from '../../elements/item-not-found'
import { QualificationTags } from '../../elements/qualification-badge'

type StaffMissionUser = {
  id: number
  staff: Staff
  missionCount: number
  isAvailable: boolean
}

type Props = {
  className?: string
  isLoading?: boolean
  missionId: number
  onCancel: () => void
  onSubmit: (user: StaffMissionUser[]) => void
}

export function MissionStaffList({ className, isLoading, missionId, onCancel, onSubmit }: Props) {
  const [selectedStaffs, setSelectedStaffs] = useState<StaffMissionUser[]>([])

  const { data: mission, isPending } = useQuery({
    queryKey: ['missions', missionId],
    queryFn: () => getMission(missionId)
  })

  //TODO : Check if Missions période column if discussed with the team to add it
  const columns: Column<IdInput<StaffMissionUser>>[] = [
    {
      enableSorting: true,
      accessorKey: 'lastName',
      header: 'NOM',
      cell: ({ row }) => row.original.staff.lastName.toUpperCase()
    },
    {
      enableSorting: true,
      accessorKey: 'firstName',
      header: 'Prénom',
      cell: ({ row }) => StringFormatter.capitalize(row.original.staff.firstName)
    },
    {
      accessorKey: 'qualifications',
      header: 'Qualifications',
      cell: ({ row }) => <QualificationTags qualifications={row.original.staff.qualifications} />
    },
    {
      header: '# missions identiques',
      accessorKey: 'missionCount'
    },
    {
      header: 'Disponible',
      accessorKey: 'isAvailable',
      cell: ({ row }) => (row.original.isAvailable ? 'Oui' : 'Non')
    }
  ]

  if (isPending) return <Loader center />
  if (!mission) return <ItemNotFound title="Mission non trouvée" />

  return (
    <div>
      <div className={className}>
        <DynamicDataTable<StaffMissionUser, StaffFilters>
          columns={columns}
          selectable
          headerType="light"
          version={'FULL'}
          permissions={{ delete: false }}
          endpoint={API.missions.getMissionStaffOptions.url.replace(':id', missionId.toString())}
          selectedData={{ rows: selectedStaffs, isAllSelected: false }}
          onSelectedDataChange={({ rows }) => setSelectedStaffs(rows)}
          filters={{ qualifications: mission.qualifications }}
        />
      </div>
      <div
        className={'flex justify-end w-full gap-3 pt-5 border-t border-t-white-active p-5 mt-5'}
      >
        <Button
          disabled={isLoading}
          variant="ghost"
          type="button"
          label={'Fermer'}
          aria-label={'Fermer'}
          onClick={onCancel}
        />
        <Button
          loading={isLoading}
          label={'Valider'}
          aria-label={'Valider'}
          onClick={() => onSubmit(selectedStaffs)}
        />
      </div>
    </div>
  )
}
